// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
// import Buefy from 'buefy'
// import 'buefy/dist/buefy.css'
import App from './App'
import router from './router'
import * as firebase from 'firebase'
import BootstrapVue from 'bootstrap-vue'
import VueSlideBar from 'vue-slide-bar'
import VueSweetalert2 from 'vue-sweetalert2'
import VueGoodWizard from 'vue-good-wizard'
// import {Tabs, Tab} from 'vue-tabs-component'
// import Tab from './views/basic-elements/Tab'
// import Tabs from './views/basic-elements/Tabs'
import store from './store'

// eslint-disable-next-line

const configOptions = {
  apiKey: 'AIzaSyAGxr92TqZYnBipkM0PcG0SOKWUYzf8248',
  authDomain: 'csvcalls.firebaseapp.com',
  databaseURL: 'https://csvcalls.firebaseio.com',
  projectId: 'csvcalls',
  storageBucket: 'csvcalls.appspot.com',
  messagingSenderId: '994427482287',
  appId: '1:994427482287:web:8ffa365db056d848b3a45a'
  // Initialize Firebase
}

Vue.prototype.$firebase = firebase.initializeApp(configOptions)

firebase.auth().onAuthStateChanged(user => {
  console.log('auth state changed!')
  console.log(user)
  store.dispatch('fetchUser', user)
})

store.state.user.data = null

const options = {
  confirmButtonColor: '#41b882',
  cancelButtonColor: '#ff7674'
}

Vue.use(BootstrapVue)
Vue.use(VueSweetalert2, options)
Vue.use(VueGoodWizard)

Vue.component('vue-slide-bar', VueSlideBar)
Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: {
    App
  },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js